import { Coffee, Droplet, Leaf, Sprout } from "lucide-react";
import { VegMark } from "@/components/z6/VegMark";
import { CategoryPattern } from "@/components/z6/CategoryPattern";

const SECTION_ICON = { Teas: Leaf, Tonics: Droplet, Matcha: Sprout, Coffee };
// Coral-family gradients, one per course, tuned to sit with the aqua theme.
export const COURSE_GRADIENT = {
  starter: "linear-gradient(150deg, #FFD3BF 0%, #FF9F87 100%)",
  main: "linear-gradient(150deg, #FF8A70 0%, #E8606A 100%)",
  dessert: "linear-gradient(150deg, #FFC6D3 0%, #F58FA0 100%)",
  beverage: "linear-gradient(150deg, #FFA78F 0%, #9FDCD3 100%)",
  broth: "linear-gradient(150deg, #FFD3BF 0%, #BFE6DC 100%)",
};
const GRAIN = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.85' numOctaves='2' stitchTiles='stitch'/%3E%3CfeColorMatrix values='0 0 0 0 0.35 0 0 0 0 0.2 0 0 0 0 0.15 0 0 0 .55 0'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

export const COURSE_NAME = { starter: "Small Plates", main: "Large Plates", dessert: "Desserts", beverage: "Drink", broth: "Broths" };

export const CourseChip = ({ course, testId, className = "" }) => (
  <span data-testid={testId} className={`font-ui rounded-full bg-white/90 px-3 py-1 text-[16px] font-normal uppercase tracking-[0.18em] text-[#0B2E44] ${className}`}>{COURSE_NAME[course]}</span>
);

export const CourseBar = ({ course }) => <span aria-hidden className="h-1.5 flex-1 rounded-full" style={{ background: COURSE_GRADIENT[course] }} />;


export const imprintKey = (dish, active) => (dish.course === "beverage" ? "beverage" : dish.course === "broth" ? "broths" : dish.menus?.includes(active) ? active : dish.menus?.[0]);


// Course gradient panel with a fine grain and a soft light sheen. No pattern art, no food photos.
export const PatternPanel = ({ course, imprint, seed, className = "", testId, children }) => (
  <div data-testid={testId} data-course={course} className={`relative overflow-hidden ${className}`} style={{ background: COURSE_GRADIENT[course] || COURSE_GRADIENT.starter }}>
    <span aria-hidden className="grain-tile absolute inset-0 opacity-[0.22] mix-blend-multiply" style={{ backgroundImage: GRAIN }} />
    {imprint && <CategoryPattern k={imprint} seed={seed || imprint} className="absolute inset-0 z-[1] h-full w-full" testId={testId ? `${testId}-pattern` : undefined} />}
    <span aria-hidden className="card-sheen absolute inset-0" style={{ background: "radial-gradient(120% 80% at 18% 8%, rgba(255,255,255,0.55), rgba(255,255,255,0) 55%)" }} />
    {children}
  </div>
);

export const Badge = ({ dish, testId, className = "" }) => {
  const Icon = SECTION_ICON[dish.section];
  return (
    <span data-testid={testId} className={`flex h-11 w-11 items-center justify-center rounded-full bg-white ring-1 ring-[#0B2E44]/10 ${className}`}>
      {dish.course === "beverage" && Icon ? <Icon className="h-4 w-4 text-[#0B2E44]" strokeWidth={1.6} aria-label={dish.section} /> : <VegMark diet={dish.diet} />}
    </span>
  );
};

// Soft aqua wash for page heroes (photos appear only on Explore menu cards).
export const SoftBackground = ({ testId }) => (
  <div aria-hidden data-testid={testId} className="absolute inset-0" style={{ background: "linear-gradient(115deg, rgba(255,255,255,0.96) 0%, rgba(232,246,244,0.92) 55%, rgba(255,226,214,0.75) 100%)" }} />
);
